<div class="nam-editable">
  <div #nameInput class="content-editable" contenteditable [formControl]="form.get(controlName)" (focusout)="nameFocusout()" (keydown.enter)="onEnterName($event, nameInput)"></div>
  <app-form-error [form]="form"
                  [maxLengthMessage]="maxLengthErrorMessage"
                  [controlName]="controlName"></app-form-error>
</div>
